import axios from "axios";
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import SpotTrade from "./Trades/SpotTrade";
import FutureTrade from "./Trades/FutureTrade";

function TradesTable({ username }) {
  const [subdata, setSubData] = useState([]);
  const [filter, setFilter] = useState("SPOT");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAPI, setselectedAPI] = useState();
  const [select, setSelect] = useState(false);


  const handlepackage = (page, size) => {
    const token = localStorage.getItem("jwt");
    const postData = {
      jwt: token,
      username: username,
    };

    axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: process.env.REACT_APP_API + "/bot/drop_down_api_list",
      data: postData,
    })
      .then((res) => {
        const responseData = res.data.Success || [];
        const formattedOptions = responseData.map((item) => ({
          label: item.API_Name,
          value: item.API_Name,
          API_Key: item.API_Key,
          API_Secret: item.API_Secret,
          Exchange_Type: item.Exchange_Type,
        }));

        setOptions(formattedOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (username) {
      handlepackage();
    }
  }, [username]);

  const handleFilterClick = (filterType) => {
    setFilter(filterType);
    setselectedAPI(null);
    setSelect(false);
  };

  const subDatasou = [];
  if (subdata.length > 0) {
    for (let i = 0; i < subdata.length; i++) {
      subDatasou.push({
        OrderID: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.OrderID}</p>
        ),
        Username: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.Username}</p>
        ),
        API_Name: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.API_Name}</p>
        ),
        Order_Type: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.Order_Type}</p>
        ),
        Price: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.Price}</p>
        ),
        Quantity: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.Quantity}</p>
        ),
        Side: (
          <p
            className={`p-1 rounded-lg text-center ${subdata[i]?.Side == "BUY" ? " text-green-500" : " text-red-500"
              }`}
          >
            {subdata[i]?.Side}
          </p>
        ),
        Type: (
          <p
            className={`p-1 rounded border-l-4 text-left font-bold pl-2
         ${subdata[i]?.Type == "PAPER"
                ? " border-[#122b45] "
                : " border-[#76c3c5] "
              }
        `}
          >
            {subdata[i]?.Type}
          </p>
        ),
        Size: <p className="p-1 rounded-lg text-center">{subdata[i]?.Size}</p>,
        Trade_Direction: (
          <p
            className={`p-1 rounded-lg text-center ${subdata[i]?.Trade_Direction == "LONG"
              ? " text-green-500"
              : " text-red-500"
              }`}
          >
            {subdata[i]?.Trade_Direction}
          </p>
        ),
        Symbol: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.Symbol}</p>
        ),
        BotName: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.BotName}</p>
        ),
        DateTime: (
          <p className="p-1 rounded-lg text-center">{subdata[i]?.DateTime}</p>
        ),
      });
    }
  }

  const filteredOptions = options.filter((option) => option.Exchange_Type === filter);



  const handleChange = (value) => {
    setselectedAPI(value);
  };

  const getSelectedApiDetails = () => {
    if (!selectedAPI) return {};
    const selectedApiObject = options.find((option) => option.value === selectedAPI);
    return selectedApiObject || {};
  };

  const selectedApiDetails = getSelectedApiDetails();

  return (
    <div>
      <div>
        <div className="flex justify-between items-center">
          <div className="flex justify-start flex-col items-start lg:space-x-4 ">

            <div className="p-2 ">
              <div className="flex mb-4 items-center justify-end">
                {/* <button
                  className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md drop-shadow-xl ${filter === "ALL"
                    ? "bg-colorSecondaryDark text-white border-2 border-white "
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  // onClick={() => handleFilterClick("ALL")}
                  onClick={() => {
                    handleFilterClick("ALL");
                    setFilter("ALL");
                  }}
                >
                  All
                </button> */}
                <button
                  className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "SPOT"
                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  // onClick={() => handleFilterClick("SPOT")}
                  onClick={() => {
                    handleFilterClick("SPOT");
                    // setFilter("SPOT");
                  }}
                >
                  Spot
                </button>
                <button
                  className={`mr-2 xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "FUTURES"
                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  // onClick={() => handleFilterClick("FUTURES")}
                  onClick={() => {
                    handleFilterClick("FUTURES");
                    // setFilter("FUTURES");
                  }}
                >
                  Future
                </button>
              </div>
            </div>
          </div>

          <Select
            style={{ width: 200 }}
            placeholder="Select an API"
            loading={loading}
            allowClear
            options={filteredOptions}
            onChange={(value) => {
              setselectedAPI(value);
              setSelect(true);
            }}
            value={selectedAPI}
          />
        </div>
      </div>

      {!select && (
        <div className='h-96 flex justify-center items-center'>
          <h1 className='text-bold bg-colorSecondaryDark animate-pulse text-white p-2 rounded-lg text-3xl'>Please Select Your API Name</h1>
        </div>
      )}
      {select && (
        filter === "SPOT" ? (
          <SpotTrade
            type={filter}
            selectedapi={selectedAPI}
            apiKey={selectedApiDetails.API_Key}
            apiSecret={selectedApiDetails.API_Secret}
            username={username}
          />
        ) : (
          <FutureTrade
            type={filter}
            selectedapi={selectedAPI}
            apiKey={selectedApiDetails.API_Key}
            apiSecret={selectedApiDetails.API_Secret}
          />
        )
      )}

    </div>
  );
}

export default TradesTable;
